import { render } from "./Skill.vue?vue&type=template&id=4d9dc1da&scoped=true"
import script from "./Skill.vue?vue&type=script&lang=js"
export * from "./Skill.vue?vue&type=script&lang=js"

import "./Skill.vue?vue&type=style&index=0&id=4d9dc1da&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d9dc1da"]])

export default __exports__